export default __webpack_public_path__ + "static/media/mob_lk_768.cba73f52.webp";